import { render, staticRenderFns } from "./TechnicalAsistanceAndTeachingSupport.vue?vue&type=template&id=8d82e138&"
import script from "./TechnicalAsistanceAndTeachingSupport.vue?vue&type=script&lang=js&"
export * from "./TechnicalAsistanceAndTeachingSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports